module.exports = __webpack_public_path__ + "img/rirosoft.f0ea4397.svg";